/* eslint-disable no-shadow */
const state = {
  notifications: ""
};

const getters = {
  getNotification: state => state.notifications
};

const mutations = {
  setNotificationMutation: (state, payload) => {
    state.notifications = payload;
  },
  clearNotifiactionMutation: state => {
    state.notifications = "";
  }
};

const actions = {
  setNotification: ({ commit }, payload) => {
    commit("setNotificationMutation", payload);
  },
  clearNotification: ({ commit }) => {
    commit("setNotificationMutation");
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
